import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function DataPullAnimation() {
    return (
        <div className="data-pull-animation-container">
            <DotLottieReact
                src="https://lottie.host/a7297303-6dd9-4d67-810a-1c0f19cc93ba/tiiOmKPKSW.lottie"
                loop
                autoplay
            />
        </div>
    )
};

export default DataPullAnimation;